export default { // consistent across mcom and bcom
  sddEligible: ' Order by __CUTOFF__ for Same-Day Delivery.',
  nddEligible: ' Eligible for Next-Day Delivery.',
  eGiftCard: 'This E-Gift Card will be emailed within __TIME__ hours to __EMAIL__',
};
